import {
    FinanceRefundPreparationForm,
    PrepareRefundResponse,
    FinanceRefundExecutionForm,
} from 'chaika-frontend-types/frontend-cms';
import { axios } from '@lib/axios';
const BASE_URL = '/api/finance/refund';

export class FinanceRefundApi {
    public static async prepareRefund(params: FinanceRefundPreparationForm): Promise<PrepareRefundResponse> {
        const res = await axios.post<PrepareRefundResponse>(BASE_URL, params);

        return res.data;
    }

    public static async refund(operationId: string, params: FinanceRefundExecutionForm): Promise<void> {
        await axios.post<PrepareRefundResponse>(`${BASE_URL}/${operationId}/execute`, params);
    }

    public static async refundByPaymentid(paymentId: string, toPersonalAccount?: boolean): Promise<void> {
        await axios.post<PrepareRefundResponse>(`/api/finance/payment/${paymentId}/refund`, { toPersonalAccount });
    }
}
